import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
import { useIntl } from "@leagueplatform/locales";
import { HeaderNavLink } from "@leagueplatform/solutions-foundation";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";

export const useNavLinksList = () => {
  const { formatMessage } = useIntl();
  const navLinksList: HeaderNavLink[] = [
    {
      to: APP_MANAGED_ROUTES.HOME,
      label: formatMessage({ id: "STR_HOME" }),
      icon: "descriptiveHome",
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
      label: formatMessage({ id: "STR_ACTIVITIES" }),
      icon: "capabilityJourney",
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.aboutMe),
      label: formatMessage({ id: "STR_INSIGHTS" }),
      icon: "descriptiveHeart",
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.careDiscovery),
      label: formatMessage({ id: "STR_HEALTH_HUB" }),
      icon: "descriptivePill",
    },
  ];
  return {
    navLinks: navLinksList,
  };
};
